import { Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';

import { formatCurrencyInBDT } from '@/utils';
import { mapPaymentMethodEnumToString } from '@/utils/mappers';

import { useOrderDetailsContext } from './context';

export const TransactionHistory = () => {
    const { data } = useOrderDetailsContext();

    const renderContent = () => {
        if (!data || !data.data) {
            return <p>No transaction data available.</p>;
        }

        const transactions = data.data?.payment?.transactions || [];

        if (transactions.length === 0) {
            return <p>No transactions found.</p>;
        }

        return transactions.map((tx, index) => {
            const date = new Date(tx.created_at);
            const timeString = date.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
            });

            const dateString = date.toLocaleDateString();
            return (
                <tr key={index} className="border-b hover:bg-muted/50">
                    <td className="px-4 py-3 text-sm">{dateString}</td>
                    <td className="px-4 py-3 text-sm">{timeString}</td>
                    <td className="px-4 py-3 text-right font-semibold">
                        {formatCurrencyInBDT(tx.amount)}
                    </td>
                    <td className="px-4 py-3 text-sm text-muted-foreground">
                        {mapPaymentMethodEnumToString(tx.payment_method ?? '')}
                    </td>

                    <td className="px-4 py-3 text-sm text-muted-foreground">
                        {tx.transaction_id}
                    </td>
                </tr>
            );
        });
    };

    return (
        <Card>
            <CardHeader>
                <CardTitle className="text-lg">Transaction History</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="border-b">
                                <th className="px-4 py-3 text-left font-semibold text-muted-foreground">
                                    Date
                                </th>
                                <th className="px-4 py-3 text-left font-semibold text-muted-foreground">
                                    Time
                                </th>
                                <th className="px-4 py-3 text-right font-semibold text-muted-foreground">
                                    Amount
                                </th>

                                <th className="px-4 py-3 text-left font-semibold text-muted-foreground">
                                    Payment Method
                                </th>

                                <th className="px-4 py-3 text-left font-semibold text-muted-foreground">
                                    Transaction ID
                                </th>
                            </tr>
                        </thead>
                        <tbody>{renderContent()}</tbody>
                    </table>
                </div>
            </CardContent>
        </Card>
    );
};
TransactionHistory.displayName = 'TransactionHistory';
